import React from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import SettingLine from "ds/SettingLine";
import OrderProjectDetail from "src/organization/pages/billing/components/ProjectDetail/ProjectDetail";
import { lineItemsByOrder } from "src/organization/pages/billing/util";

import * as S from "./OrderProjectList.styes";

const OrderProjectList = props => {
  const { order, expandedItem, title, expand } = props;
  const intl = useIntl();

  const lineItems = lineItemsByOrder(order);

  return (
    <S.Layout>
      <S.Title tag="h4">{title}</S.Title>
      {Object.keys(lineItems).map(subscriptionId => (
        <SettingLine
          key={subscriptionId}
          id={`billing-history-recurring-${subscriptionId}`}
          info={
            <S.BodyText weight="bold">
              {lineItems[subscriptionId].title
                ? lineItems[subscriptionId].title
                : "Untitled Project"}
            </S.BodyText>
          }
          isOpen={expandedItem === subscriptionId}
          openText={intl.formatMessage({ id: "view" })}
          onClick={() => {
            expand(subscriptionId);
          }}
        >
          {expandedItem === subscriptionId && lineItems[subscriptionId] && (
            <OrderProjectDetail
              lineItemsByOrder={lineItems}
              totals={lineItems[subscriptionId].components}
              subscriptionId={subscriptionId}
            />
          )}
        </SettingLine>
      ))}
    </S.Layout>
  );
};

OrderProjectList.propTypes = {
  orders: PropTypes.object,
  orderDetails: PropTypes.object,
  expandedItem: PropTypes.string,
  title: PropTypes.string,
  loadOrder: PropTypes.func,
  expand: PropTypes.func,
  intl: PropTypes.object,
  titleFilter: PropTypes.string,
  isLoading: PropTypes.bool,
  organizationId: PropTypes.string,
  order: PropTypes.object
};

export default OrderProjectList;
